import axios from 'axios'
import { host } from '../../configuraciones'
import {createAsyncThunk,createSlice} from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: [],
    clientesDescuento:[]
}
//types
const OBTENER_CLIENTES_DESCUENTO_PREDIO_EXITO= 'OBTENER_CLIENTES_DESCUENTO_PREDIO_EXITO'
const AGREGAR_DESCUENTO_PREDIO_EXITO= 'AGREGAR_DESCUENTO_PREDIO_EXITO'

const ACTUALIZAR_DESCUENTO_PREDIO_EXITO= 'ACTUALIZAR_DESCUENTO_PREDIO_EXITO'


export const obtenerAllClientesDescuentoPredio = createAsyncThunk(
    OBTENER_CLIENTES_DESCUENTO_PREDIO_EXITO,
    async () => {
        try {
            const fullUrl = host + `DescuentoMaguey/obtenerTodosLosClientesDescuento`
            let res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarDescuentoPredio = createAsyncThunk(
    AGREGAR_DESCUENTO_PREDIO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `DescuentoPredio/agregarDescuentoPredio`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


export const actualizarDescuentoPredio = createAsyncThunk(
    ACTUALIZAR_DESCUENTO_PREDIO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `DescuentoPredio/actualizarDescuentoPredio`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


//Reducers
export const DescuentoPredioSlice = createSlice({
    name: 'DescuentoPredioSlice',
    initialState: dataInicial,
    reducers: {
       
    },
    extraReducers: {
      
        [obtenerAllClientesDescuentoPredio.fulfilled]: (state, { payload }) => {
            state.clientesDescuento = payload
        },
        [agregarDescuentoPredio.fulfilled]: (state, { payload }) => {
        },

        [actualizarDescuentoPredio.fulfilled]: (state, { payload }) => {
       
        },
    },
})

export const {
} = DescuentoPredioSlice.actions
export const DescuentoPredioReducerUsuarioAgricola = DescuentoPredioSlice.reducer
